<template>
    <div class="inquiry_main">
        <p class="current">当前位置：<span>询价</span></p>
        <div class="inquiry_info">
            <div class="info_title">
                <p>询价企业</p>
                <p>{{ company_name }}</p>
            </div>
            <div class="info_title">
                <p>询价产品</p>
                <el-button type="primary" @click="NewProduct">新增产品+</el-button>
            </div>
            <div class="info_context">
                <!-- <div  v-for="(item,index) in products" :key="index">

                </div> -->
                <div class="showInfo" v-for="(item,index) in products" :key="index">
                    
                    <div class="imgBox" :style="'background-image:url('+item.product_img+');'"></div>
                    <div class="info_left">
                        <div>
                            <p>{{ item.product_name }}</p>
                            <p>数量：{{ item.quantity }}</p>
                            <p>预期价格： {{ item.expected_price }}</p>
                            <p v-show="item.product_describe != ''">{{item.product_describe}}</p>
                        </div>
                        <div class="caoz">
                            <span @click="EditProduct(index)">修改</span>
                            <span @click="DelProduct(index)">删除</span>
                        </div>
                    </div>
                </div>

            </div>
            <div v-show="EditShow" class="info_addInput">
                <div class="info_title">
                    <p>名称</p>
                    <el-input v-model="product_name" placeholder="请填写名称"></el-input>
                </div>
                <div class="info_title">
                    <p>备注</p>
                    <el-input v-model="product_describe" placeholder="请填写备注"></el-input>
                </div>
                <div class="info_title">
                    <p>预期价格</p>
                    <el-input v-model="expected_price"  placeholder="请填写预期价格" @input="handleInput"></el-input>
                </div>
                <div class="info_title">
                    <p>数量</p>
                    <el-input-number v-model="quantity" :min="1" ></el-input-number>
                </div>
                
                <div class="info_title" style="border: none;">
                    <p>图片LOGO</p>
                    <div class="list-card-img">
                        <img width="200px" height="150px" v-show="product_img != ''" :src="product_img" alt="">
                        <el-upload
                            ref="upload"
                            :http-request="handleTransform"
                            action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                        >
                            <i class="el-icon-plus borderI" ></i>
                        </el-upload>
                    </div>
                </div>
                <div>
                    <el-button type="primary" @click="SubmitProduct">确定</el-button>
                    <el-button type="primary" @click="CancelEdit">取消</el-button>
                </div>
            </div>

            
        </div>
        <div class="submit_but">
            <el-button type="primary" @click="VSSubmit">提交</el-button>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default{
    data(){
        return{
            xid: -9,
            vsurl: '',
            vstoken:'',
            companytype: [],
            company_type_index: 0,
            company_type_id: '',
            company_type_name: '选择类别',
            info: {},
            form: {
                company_ids: '',
                cates: '',
                type: ''
            },
            name: '',
            code: '',
            real_name: '',
            phone: '',
            remarks: '',
            file_items: [],
            FileData:[],
            imgHeight:80,
            description: '',
            SKCode: '',
            audit_status: -9,
            vsid: -9,
            isedit: -9,
            products: [],
            products0: [
                {
                    product_name: '安全帽002',
                    product_describe: '特别防护',
                    quantity: 2,
                    expected_price: '',
                    product_img: 'https://qiliangong.oss-cn-shenzhen.aliyuncs.com/2023-07-04/a0f6f09f-2bb7-4b6b-8965-0a56b7b4140e.jpeg'
                }
            ],
            company_name: '',
            company_id: '',
            company_ids: '',
            product_form: {
                product_name: '',
                quantity: 1,
                expected_price: '',
                product_describe: '',
                product_img: ''
            },
            product_name: '',
            quantity: 1,
            expected_price: '',
            product_describe: '',
            product_img: '',
            pindex: -9,
            EditShow: false
        }
    },
    methods: {
        NewProduct(){
            this.pindex = -9
            this.ResetForm()
            this.EditShow = true
        },
        ResetForm(){
            this.product_img = ''
            // this.product_form = {
            this.product_name = '',
            this.quantity = 1,
            this.expected_price = '',
            this.product_describe = '',
            this.product_img = ''
            // }
        },
        getUUID(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })  
        },
        fileToBlob(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    resolve(blob);
                };

                reader.onerror = reject;

                reader.readAsArrayBuffer(file);
            });
        },
        // 上传文件
        handleTransform(file){
            
            let data = {}
            this.$store.dispatch('train/policy',data)
                .then(res => {
                    if(res.ok){

                        this.fileToBlob(file.file).then(blob => {
                           
                            var info = res.data
                            var key = info.dir + this.getUUID() + file.file.name.substring(file.file.name.lastIndexOf(".")) 
                            
                            console.log('key')
                            console.log(key)
                            let formData = new FormData()

                            formData.append('key', key)
                            formData.append('OSSAccessKeyId', info.accessId)
                            formData.append('policy', info.policy)
                            formData.append('signature', info.signature)
                            formData.append('success_action_status', '200')
                            formData.append('file', file.file)
                            
                            axios({
                                url: info.host,
                                contentType: false,
                                method: 'post',
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(res => {
                                const { status } = res
                                if (status === 200) {
                                    var filename = file.file.name
                                    var pictureUrl = info.host + '/' + key;//获得到的url需要将其存数据库中
                                    this.product_img = pictureUrl
                                    // this.file_items.push({
                                    //     filename: filename,
                                    //     lanmu: 'booking',
                                    //     picurl: pictureUrl,
                                    //     FileName: filename,
                                    //     FileUrl: pictureUrl,

                                    // })  
                                  
                                
                                } 
                            })
                     
                        });
						
						
					}
                })
           
        },
        handleInput() {
            // 过滤非数字字符
            this.expected_price = this.expected_price.replace(/[^\d]/g, '');
        },
        SubmitProduct(){
            // 
            if(this.product_name != '' &&  this.product_img != ''){
                var index = this.pindex
                
                var PostData = {}
                var product_name = this.product_name
                // if(!this.errTipsX(product_name, '产品名称', 'text', 'empty', '')){
                //     return false
                // }
                PostData['product_name'] = product_name
                
                var product_describe = this.product_describe
                PostData['product_describe'] = product_describe
                
                var quantity = this.quantity
                PostData['quantity'] = quantity
                
                var expected_price = this.expected_price
                PostData['expected_price'] = expected_price

                var product_img = this.product_img
                PostData['product_img'] = product_img
                
                var products = this.products
                
                if(index < 0){
                    products.push(PostData)
                }else{
                    products[index] = PostData
                }
                console.log(products)
                this.ResetForm()
                this.products = products
                this.EditShow = false
            }else if(this.product_name == ''){
                this.$notify({
                    title: '提示',
                    message: '请填写商品名称',
                    type: 'warning'
                })
            }else if(this.product_img == ''){
                this.$notify({
                    title: '提示',
                    message: '请上传图片',
                    type: 'warning'
                })
            }
        },
        CancelEdit(){
            this.EditShow = false
        },
        EditProduct(index){
            this.pindex = index
            var products = this.products
            var info = products[index]
            this.product_name = info.product_name
            this.product_describe = info.product_describe
            this.expected_price = info.expected_price
            this.quantity = info.quantity
            this.product_img = info.product_img
            this.EditShow = true
        },
        DelProduct(index){
            var products = this.products
            products.splice(index, 1)
            this.products = products
        },
        VSSubmit(){			
			// inquiry_id,user_id,product_name,product_describe,product_img,quantity,expected_price
            var PostData={}
            
            var company_id = this.company_id
            
            this.form.company_ids = company_id
            
            this.form.type = '0'
            
            var products = this.products
            
            
            this.form.product_list = JSON.stringify(products)
            
            console.log(this.form)
            //return false

            
            this.$store.dispatch('enable/add',this.form)
                .then(res => {
                    if(res.ok){
                        this.$router.push({
                            path: '/myInquiry',
                        })
                    }else if(res.data == 'notlogin' ){
                        this.$notify({
                            title: '提示',
                            message: '未登录，请先登陆',
                            type: 'error'
                        })

                        this.$router.push('/login')
                    }
                })
           
        },
    },
    mounted(){
        this.company_name = this.$route.query.company_name
		this.company_id = this.$route.query.company_id
    }
}
</script>

<style scoped lang="scss">
.inquiry_main{
    background: #fff;
    width: 1190px;
    padding-bottom: 30px;
    min-height: calc(100vh - 215px);
    margin: 45px auto;
    position: relative;
    .current{
       
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 17px;
            cursor: pointer;
            color: #666666;
        }
    }
    .inquiry_info{
        width: 1180px;
        margin: 25px auto;
        padding: 10px 10px;
        position: relative;
        .info_title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 0.5px solid #f2f2f2;
            margin: 5px 0 10px 0;
            font-size: 18px;
            color: #333333;
            padding: 10px 10px;
            p:nth-child(1){
                color: #666666;
            }
            .el-input{
                width: 300px;
            }
        }

       
    }

    .info_addInput{
        width: 95%;
        margin: 20px auto;
        background-color: #f2f2f2;
        padding: 10px 8px;
        .info_title{
            border-bottom: 0.5px solid #e6e6e6;
            .list-card-img{
                width: 80%;
                text-align: right;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                flex-flow: row wrap;
                .borderI{
                    text-align: center;
                    cursor: pointer;
                    width: 200px;
                    outline: 0;
                    height: 150px;
                    line-height: 150px;
                    border-radius: 5px;
                    border: 1px dashed #999999;
                    font-size: 20px;
                    color: #999999;
                    margin-left: 5px;
                }
                ::v-deep .el-upload-list__item{
                    display: none !important;
                }
            }
            
        }
    }

    .info_context{
        display: flex;
        justify-content: flex-start;
        align-content: center;
        flex-flow: row wrap;
        padding: 0 20px;
        .showInfo{
            width: 328px;
            margin: 20px 5px 0 5px;
            border: 1px solid #f2f2f2;
            padding: 10px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;              
            border-radius: 10px;
            font-size: 18px;
            color: #333333;
            cursor: pointer;
            .imgBox{
                width: 120px;
                height: 120px;
                border: 1px solid #f2f2f2;
                border-radius: 10px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                margin-right: 10px;
            }
            .info_left{
                width: 200px;
                
                p{
                    font-size: 16px;
                    line-height: 25px;
                    color: #333333;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .caoz{
                    text-align: right;
                    span{
                        margin-left: 10px;
                        cursor: pointer;
                        font-size: 12px;
                        color: #666666;
                        text-align: right;
                    }
                    span:hover{
                        color: #10aeff;
                    }
                }
            }
            
            
        }
        .showInfo:hover{
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
        }
    }

    .submit_but{
        position: absolute;
        bottom: 10px;
        left: 20px;
        .el-button{
            width: 200px;
        }
    }
    
}

</style>